"use client";

import { useEffect } from "react";

/**
 * Global error boundary for the entire application.
 *
 * Catches unhandled errors in any route segment that does not have its own
 * error boundary. Renders a minimal centered card with a "Try again" button
 * that resets the error state and re-renders the failed segment.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Global error:", error);
  }, [error]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="rounded-xl border bg-card p-12 text-center max-w-md">
        <h2 className="text-2xl font-bold">Something went wrong</h2>
        <p className="mt-2 text-muted-foreground">
          An unexpected error occurred.
        </p>
        <button
          onClick={reset}
          className="mt-4 rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
        >
          Try again
        </button>
      </div>
    </div>
  );
}
